import React from 'react';
import { Button as Button$1 } from '@mui/material';
import { styled } from '@mui/material/styles';

const Button = styled(Button$1, {
    shouldForwardProp: p => p !== "themeType" && p !== "showOpacity",
}) `
    && {
        width: 100%;
        height: 100%;
        font-family: ${({ theme }) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
        font-size: inherit;
        text-transform: inherit;
        font-weight: inherit;
        letter-spacing: inherit;
        margin: 0;
        border: ${({ theme, themeType }) => theme.colours.form[`button${themeType}`].border};
        color: ${({ theme, themeType }) => theme.colours.form[`button${themeType}`].color};
        opacity: ${({ showOpacity, theme, themeType }) => showOpacity ? theme.colours.form[`button${themeType}`].opacity : 1};
        border-radius: ${({ theme, themeType }) => theme.colours.form[`button${themeType}`].radius};
        background-color: ${({ theme, themeType }) => theme.colours.form[`button${themeType}`].background};
        :active,
        :focus,
        :visited,
        :hover {
            background-color: ${({ theme, themeType }) => theme.colours.form[`button${themeType}`].background};
            color: ${({ theme, themeType }) => theme.colours.form[`button${themeType}`].color};
        }
        padding: 0.46875rem 1rem;
        text-align: center;
    }
    span {
        color: ${({ theme, themeType }) => theme.colours.form[`button${themeType}`].color};
    }
`;

const CTA = ({ enable, url, text, themeType, onClick, testId, dataGaV1, dataGaV2, dataGaV3 }) => {
    return (React.createElement(Button, { href: url, onClick: onClick, disabled: !enable, showOpacity: !enable, themeType: themeType, disableRipple: true, "data-testid": testId, "data-ga-v1": dataGaV1, "data-ga-v2": dataGaV2, "data-ga-v3": dataGaV3 }, text));
};

export { CTA };
